import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CloseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 20 20">
    <path
      d="M1.03331 20.0001C0.769865 20.0001 0.506416 19.8998 0.306254 19.6982C-0.0955744 19.2964 -0.0955744 18.6449 0.306254 18.2431L18.2479 0.301372C18.6497 -0.100457 19.3012 -0.100457 19.703 0.301372C20.1049 0.703201 20.1049 1.35467 19.703 1.75675L1.76163 19.6982C1.55996 19.8986 1.29651 20.0001 1.03331 20.0001Z"
      fill={props.stroke}
    />
    <path
      d="M18.9762 20.0001C18.7128 20.0001 18.4496 19.8998 18.2492 19.6982L0.306254 1.75675C-0.0955744 1.35467 -0.0955744 0.703201 0.306254 0.301372C0.708083 -0.100457 1.35955 -0.100457 1.76163 0.301372L19.703 18.2431C20.1049 18.6449 20.1049 19.2964 19.703 19.6982C19.5014 19.8986 19.2382 20.0001 18.9762 20.0001Z"
      fill={props.stroke}
    />
  </SvgIcon>
);
